var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _ellipse, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var Svg403 = function Svg403(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 214,
    viewBox: "0 0 350 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 4.72656,
    width: 219,
    height: 159.273,
    rx: 11,
    fill: "#F1F9FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82.4204,
    y: 23.3906,
    width: 52.2614,
    height: 32.3523,
    rx: 6,
    fill: "#E5F1F9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 82.4204,
    y: 68.1875,
    width: 119.455,
    height: 79.6364,
    rx: 6,
    fill: "#E5F1F9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 148.369,
    y: 23.3906,
    width: 53.5057,
    height: 32.3523,
    rx: 6,
    fill: "#E5F1F9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 215.562,
    y: 23.3906,
    width: 52.2614,
    height: 32.3523,
    rx: 6,
    fill: "#E5F1F9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 215.562,
    y: 68.1875,
    width: 52.2614,
    height: 79.6364,
    rx: 6,
    fill: "#E5F1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M302.495 86.6246L306.016 99.1775C303.286 99.5567 300.246 100.216 296.882 101.095L293.528 89.1399C288.246 70.3106 279.405 59.2501 253.343 66.5614C227.28 73.8726 225.482 87.918 230.764 106.747L234.118 118.703C230.787 119.701 227.849 120.719 225.319 121.816L221.798 109.263C216.935 91.9277 214.663 67.7402 250.827 57.595C286.991 47.4498 297.632 69.2896 302.495 86.6246Z",
    fill: "#BBDEFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.882 101.095C300.246 100.216 303.285 99.5569 306.016 99.1777C321.779 96.7547 328.059 103.053 333.66 123.018L337.014 134.973C343.722 158.883 339.421 166.538 315.511 173.245L255.735 190.014C231.824 196.722 224.17 192.421 217.462 168.511L214.109 156.556C208.508 136.591 210.596 127.945 225.319 121.816C227.848 120.719 230.787 119.702 234.118 118.703L296.882 101.095ZM283.385 142.184C284.185 145.035 283.334 147.959 281.405 149.937L283.495 157.386C284.092 159.513 282.851 161.721 280.724 162.318C278.597 162.914 276.389 161.674 275.792 159.547L273.702 152.097C271.027 151.411 268.779 149.356 267.98 146.505C266.786 142.251 269.267 137.835 273.521 136.642C277.776 135.449 282.192 137.93 283.385 142.184Z",
    fill: "url(#paint0_linear_1516_136651)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 274.5,
    cy: 208,
    rx: 68.5,
    ry: 6,
    fill: "url(#paint1_linear_1516_136651)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1516_136651",
    x1: 215.419,
    y1: 126.95,
    x2: 260.582,
    y2: 189.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3F2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBDEFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1516_136651",
    x1: 208.283,
    y1: 210.4,
    x2: 337.358,
    y2: 208.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F2FA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F3FC"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(Svg403);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "403.9a0df2ff12461e8c67c48761268f0cee.svg";